import { render, staticRenderFns } from "./ServiceReportDetails.vue?vue&type=template&id=65287e16&"
import script from "./ServiceReportDetails.vue?vue&type=script&lang=js&"
export * from "./ServiceReportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports